import { Component, LOCALE_ID, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { Title } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [{ provide: LOCALE_ID, useValue: 'es-ES' }],
})
export class AppComponent {
  title = environment.appTitle;

  constructor(private readonly titleService: Title) {
    this.setTitle();
    registerLocaleData(localeEs, 'es-ES');
  }

  private setTitle() {
    this.titleService.setTitle(this.title);
  }
}
